

export class VehicleDetailReminderDataInput implements IVehicleDetailReminderDataInput {
    /** The auto-generated id of the vehicle details master */
    vehicleDetailsId!: number;

    constructor(data?: IVehicleDetailReminderDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleDetailsId = _data["vehicleDetailsId"];
        }
    }

    static fromJS(data: any): VehicleDetailReminderDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDetailReminderDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleDetailsId"] = this.vehicleDetailsId;
        return data; 
    }
}

export interface IVehicleDetailReminderDataInput {
    /** The auto-generated id of the vehicle details master */
    vehicleDetailsId: number;
}

